import { AppRouteProps } from "@harea/component";
import React from "react";

const RoleListContainer = React.lazy(() => import("./containers/RoleListContainer"));
const RoleFormContainer = React.lazy(() => import("./containers/RoleFormContainer"));

export const RoleRoutes: Array<AppRouteProps> = [
    {
        path: "role",
        title: "Bo.Role.List.Title",
        element: <RoleListContainer />,
        children: [
            {
                path: "create",
                title: "Bo.Role.Create.Title",
                element: <RoleFormContainer />,
            },
            {
                path: ":id/edit",
                title: "Bo.Role.Edit.Title",
                element: <RoleFormContainer />,
            },
        ],
    },
];